/* eslint-disable @typescript-eslint/no-explicit-any */
import {Input} from "../input/Input";
import {createRange} from "./create_range";

// leaving this as 'any'
// TODO: we should really refactor range form components or create dedicated InputRange instead of recreating this thing below
export const InputRange = createRange(Input as any);
